import { fetchWPBlogPosts } from '../helpers/api'

export async function populateBlogPosts () {
  const posts = await fetchWPBlogPosts({ per_page: 3, _embed: true })

  for (const post of posts) {
    createPostBlock(post)
  }
}

function createPostBlock (post) {
  const body = document.getElementById('posts-body')
  const imgLink = post._embedded['wp:featuredmedia']?.[0]?.source_url
  const wrapper = document.createElement('div')
  const _post = document.createElement('a')

  wrapper.id = `post-${post.slug}`
  wrapper.classList.add('post-wrapper')
  _post.classList.add('post')
  _post.href = post.link

  if (imgLink) {
    const image = document.createElement('img')
    image.src = imgLink
    image.classList.add('post-image')
    _post.appendChild(image)
  } else {
    const imagePlaceholder = document.createElement('div')
    imagePlaceholder.classList.add('post-image')
    _post.appendChild(imagePlaceholder)
  }

  if (post.title.rendered) {
    const title = document.createElement('p')

    title.classList.add('title')
    title.innerText = post.title.rendered.replace('&#038;', '&')
    _post.appendChild(title)
  }

  if (post.excerpt.rendered) {
    const excerpt = document.createElement('p')

    excerpt.classList.add('excerpt')
    excerpt.innerText = post.excerpt.rendered.replace(/<.*?>/g, '').replace(/\[.*?\]/g, '')
    _post.appendChild(excerpt)
  }

  // const dashedName = _block.home_block.replace('_', '-')
  // block.classList.add('camp-block-large')
  // if (_block.main_image) block.style.backgroundImage = `url(${_block.main_image})`

  wrapper.appendChild(_post)
  body.appendChild(wrapper)
}
